
import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { ManageUser } from '../model/user.model';

@Pipe({
    name: 'myFilter'
})
@Injectable()
export class FilterPipe implements PipeTransform {
        transform(items: ManageUser[], filter: string): any {
            console.log(items);
            // console.log(filter);

            
            if (!items || !filter) {
                return items;
            }
            // filter items array, items which match and return true will be
            // kept, false will be filtered out
          
          
              return items.filter(item => {
                  item.role.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
                 
                  
                });

            // return items.filter(function(hero){
            //     return hero.username == filter;
            // });
        }
    }


    // var heroes = [
    //     {name: “Batman”, franchise: “DC”},
    //     {name: “Ironman”, franchise: “Marvel”},
    //     {name: “Thor”, franchise: “Marvel”},
    //     {name: “Superman”, franchise: “DC”}
    // ];
    
    // var marvelHeroes =  heroes.filter(function(hero) {
    //     return hero.franchise == “Marvel”;
    // });